module.exports = __webpack_public_path__ + "static/media/tamara_rau.f18d9b82.jpg";